import React from 'react';
import { Helmet } from 'react-helmet';

export const MerchantLink: React.FC = () => {
  const path = window.location.pathname.split('/')[2];
  const manifestUrl = `${window.location.origin}/online-ordering/${path}`;
  const manifestData = {
    short_name: 'Clover',
    name: 'Clover Order Ahead',
    icons: [
      {
        src: 'clover_logo_144.png',
        sizes: '144x144',
        type: 'image/png',
      },
      {
        src: 'clover_logo_168.png',
        sizes: '168x168',
        type: 'image/png',
      },
      {
        src: 'clover_logo_192.png',
        sizes: '192x192',
        type: 'image/png',
      },
    ],
    start_url: `${manifestUrl}`,
    display: 'standalone',
    theme_color: '#228800',
    background_color: '#fbfbfb',
  };
  const content = encodeURIComponent(JSON.stringify(manifestData));
  const url = `data:application/manifest+json,${content}`;

  return (
    <Helmet>
      <link rel="manifest" href={url} />
    </Helmet>
  );
};
